import { z } from 'zod';

export const faceviewPlusSchema = z.object({
    idNumber: z.string({ error: 'ID Number is required' })
        .regex(/^\d+$/, "ID Number must be numeric"),
    firstName: z.string().optional().or(z.literal('')),
    surname: z.string().optional().or(z.literal('')),
    yourReference: z.string().optional().or(z.literal('')),
    voucherCode: z.string().optional().or(z.literal('')),
});

export type FaceviewPlusPayload = z.infer<typeof faceviewPlusSchema>;

export const faceviewPlusService = {
    createPayload: (formData: z.infer<typeof faceviewPlusSchema>): FaceviewPlusPayload => {
        return {
            ...formData
        };
    },

    executeReport: async (payload: FaceviewPlusPayload): Promise<any> => {
        const axios = (await import('../axiosConfig')).default;
        // Make sure the number is passed correctly
        const formattedPayload = {
            ...payload,
            idNumber: parseInt(payload.idNumber, 10)
        };
        const response = await axios.post('/verification/faceview-plus', formattedPayload);
        return response.data;
    }
};
